const COLORS: Record<string, string> = {
  active: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  trialing: 'bg-sky-50 text-sky-700 ring-sky-200',
  past_due: 'bg-red-50 text-red-700 ring-red-200',
  canceled: 'bg-slate-100 text-slate-600 ring-slate-200',
  incomplete: 'bg-amber-50 text-amber-800 ring-amber-200',
};

export function StatusChip({ status }: { status: string | null | undefined }) {
  if (!status) return <span className="text-muted-foreground">—</span>;
  const cls = COLORS[status] ?? 'bg-slate-100 text-slate-600 ring-slate-200';
  return <span className={`inline-flex rounded px-1.5 py-0.5 text-xs ring-1 ${cls}`}>{status.replace('_', ' ')}</span>;
}

export function SuppressedChip({ reason }: { reason: string | null | undefined }) {
  if (!reason) return null;
  return (
    <span className="inline-flex rounded px-1.5 py-0.5 text-xs bg-red-50 text-red-700 ring-1 ring-red-200">
      {reason}
    </span>
  );
}
